export { PolicyWizardService } from "./policy-wizard.service";
export { PolicyResourceSelectComponent } from "./policy-resource-select/policy-resource-select.component";
export { PolicyAccessSelectComponent as PolicyGroupSelectComponent } from "./policy-access-select/policy-access-select.component";
export { SamlAliasCreateComponent } from "./saml-alias-create/saml-alias-create.component";
